import type { FunctionComponent } from "react";
import { useSdkContext } from "scmp-sdk/components/contexts";

import { BaseLink } from "shared/components/common/base-link";

import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";
import { useMastheadTracking } from "scmp-app/components/header/hooks";
import { page as NewsletterPage } from "scmp-app/pages/newsletters";

import { Container, StyledIconNewsletter } from "./styles";

export type HeaderFeaturesNewsletterProps = HeaderFeatureCommonProps;

export const HeaderFeaturesNewsletter: FunctionComponent<HeaderFeaturesNewsletterProps> = ({
  ...props
}) => {
  const { handleTrackGA4 } = useSdkContext();

  const handleClick = () => {
    handleTrackGA4({
      action: "click",
      category: "nl",
      customized_parameters: {
        internal_campaign: "",
        trigger_point: "masthead",
      },
      subcategory: "entry",
    });
  };

  const mastheadQueryParameter = useMastheadTracking();

  return (
    <Container {...getResponsiveProps(props)}>
      <BaseLink
        anchorProps={{ "aria-label": "newsletter" }}
        {...NewsletterPage.route({})}
        onClick={handleClick}
        query={mastheadQueryParameter}
      >
        <StyledIconNewsletter />
      </BaseLink>
    </Container>
  );
};
